export default function Go_Conditions () {
  return (
    <div>
      <h1>Go_Conditions </h1>
      <p>Conditions</p>
    </div>
  );
}